import { IBusinessFull } from "../../../interfaces/businessFull.interface";
import { OnlinePricingStructure } from "../../../interfaces/onlinePricing.interface";

// The online pricing shapes this build can express completely, and so may
// safely replace. Both online write paths ($set on editBusiness and
// PUT /businesses/{id}/pricing) replace onlinePricing wholesale.
const EDITABLE_ONLINE_STRUCTURES: string[] = [
  OnlinePricingStructure.FourBucket,
  OnlinePricingStructure.SixteenBucket,
];

/** Whether the merchant is priced on a structure no editor here can express in
 *  full. A wholesale replace would then drop every group the editor omits, so
 *  the online panes read as not editable and saves leave onlinePricing alone. */
export function hasUneditableOnlinePricing(
  business: Pick<IBusinessFull, "onlinePricingStructure"> | undefined | null
): boolean {
  const structure = business?.onlinePricingStructure;
  return !!structure && !EDITABLE_ONLINE_STRUCTURES.includes(structure);
}
